module.exports = __webpack_public_path__ + "static/media/Аннотации_2.5cd3dbef.pdf";